import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import RegisteredManager from './Lists/RegisteredManager';
import { ConnectManager } from './mapper/MapperListManager';
import { iListRegisteredManager } from './interface';
import { makeReduxDataPagination } from '~/main/factories/usecases/dataPagination/SetDataFactory';
import { ListEmpty } from '../componentEmpty';
import { iStore } from '~/domain/interfaces/models';
import { translator } from '../i18n';

const ListRegisteredManager: React.FC = () => {
  const { dataPagination } = useSelector(
    (store: iStore) => store.dataPagination,
  );
  useEffect(() => {
    makeReduxDataPagination().set([]);
    // return () => {};
  }, []);

  const { loading } = useSelector((store: iStore) => store.users);

  return dataPagination.length === 0 && !loading ? (
    <ListEmpty
      message={translator(
        'Os organizadores cadastrados aparecerão aqui. No momento não há nenhum',
      )}
    />
  ) : (
    <RegisteredManager dataList={dataPagination} />
  );
};

export default ListRegisteredManager;
